import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { AllocationsConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AllocationsService } from './api/allocations.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class AllocationsApiModule {
    public static forRoot(configurationFactory: () => AllocationsConfiguration): ModuleWithProviders<AllocationsApiModule> {
        return {
            ngModule: AllocationsApiModule,
            providers: [ { provide: AllocationsConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: AllocationsApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('AllocationsApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
